﻿export default class GlobalSearch {

    constructor() {
        this.SIMPLESEARCH = "s";
        this.SEARCH_MIN_LENGTH = 2;

        this.getSearchCriteria = this.getSearchCriteria.bind(this);
        this.getParamError = this.getParamError.bind(this);
        this.refreshResults = this.refreshResults.bind(this);
        this.showSpinner = this.showSpinner.bind(this);
        this.hideSpinner = this.hideSpinner.bind(this);

        this.spinnerCount = 0;          // spinner semaphore
    }

    initializeSearchIndex(searchPage) {
        //const self = this;
        //$(searchPage.containerId).floatLabels();          // not sure if useful for checkbox

        // sidebar link
        //const showFilterButtonContainer = $(`${searchPage.containerId} .page-main .sidebar-link`);
        //$(`${searchPage.containerId} .page-sidebar.refine-search`).collapsibleSidebar(showFilterButtonContainer);

        window.cpiBreadCrumbs.addNode({
            name: $(searchPage.containerId).attr("id"),
            label: searchPage.title,
            url: searchPage.url,
            refresh: true,
            updateHistory: true
        });
        pageHelper.moveBreadcrumbs(searchPage.containerId);
    }

    initializeMidPane() {

        const self = this;
        // SEARCH MODE 
        const searchMode = $("#SearchMode").find(".btn.active input")[0].value;
        self.showSearchContainer(searchMode);
        $("#SearchMode input").on("change", function () {
            self.showSearchContainer($(this).val());
        });

        // SEARCH SCOPE 
        self.addScopeEvent("chkSearchData", "globalSearchDataTab", null);
        self.addScopeEvent("chkSearchDoc", "globalSearchDocTab", "cpiDocParamContainer");
    }


    addScopeEvent(chkbox, tab, paramContainer) {
        $(`#${chkbox}`).change(function () {
            if (this.checked) {
                if (paramContainer) {
                    $(`#${paramContainer}`).show();
                    $(`#${paramContainer}Header`).show();
                }
                //$(`#${tab}`).show();
                //$(`#${tab}Content`).show();
            }
            else {
                if (paramContainer) {
                    $(`#${paramContainer}`).hide();
                    $(`#${paramContainer}Header`).hide();
                }
                //$(`#${tab}`).hide();
                //$(`#${tab}Content`).hide();
            }
        });
    }

  
    // BASIC SEARCH
    initializeBasicSearch(searchWarning) {
        const self = this;
        const simpleContainer = $("#searchSimpleContainer");

        simpleContainer.find(".cpiGlobalSearchBasic").on("click", function (e) {
            e.preventDefault();

            // check for param errors
            const errors = self.getBasicError(searchWarning);
            if (errors.length) {
                cpiAlert.warning(errors);
                return;
            }

            // refresh grid
            self.refreshResults(self.SIMPLESEARCH);
        });

        // toggle - open/close screens per system
        $("#toggleScreenList").click(function () {
            const button = $(this).find("i");
            button.toggleClass("fal fa-chevron-down").toggleClass("fal fa-chevron-up");
            if (button.attr('class').includes('up')) {
                $("#cpiSysParamContainer .collapse").collapse("show");
            }
            else {
                $("#cpiSysParamContainer .collapse").collapse("hide");
            }
        });

        // check all system
        $("#chkSystemAll").change(function () {
            const isChecked = $(this).is(":checked");
            $("#cpiSysParamContainer .k-checkbox").prop("checked", isChecked);
            $("#cpiSysParamContainer .cpiSystemCheck").prop("checked", isChecked);
        });

        // system checkboxes change event
        $("#cpiSysParamContainer .cpiSystemType .k-checkbox").change(function () {
            const parentChkboxId = $(this).attr("id");
            const isChecked = $("#" + parentChkboxId).is(":checked");
            const childrenSelector = "#cpiSysParamContainer .cpiScreenType ." + parentChkboxId;       // the children has the parent's id in its class
            $(childrenSelector).prop("checked", isChecked);
        });

        // children checkbox change event
        $("#cpiSysParamContainer .cpiSystemCheck").change(function () {
            const classes = $(this).attr("class").split(" ");           // parent id is in the child checkbox's class
            const parentChkboxId = classes[classes.length - 1];
            // if child chkbox checked, check its parent
            if ($(this).is(":checked")) {
                $("#" + parentChkboxId).prop("checked", true);
            }
            // else uncheck its parent only if all children are unchecked
            else {
                let allClear = true;
                const childrenSelector = "#cpiSysParamContainer .cpiScreenType ." + parentChkboxId;       // the children has the parent's id in its class
                $(childrenSelector).each(function () {
                    allClear = allClear && !this.checked;       // faster bit-wise op
                    //if (this.checked) {
                    //    allClear = false;
                    //}
                })
                if (allClear) {
                    $("#" + parentChkboxId).prop("checked", false);
                }
            }
        });

        // check all document
        $("#chkDocumentAll").change(function () {
            const isChecked = $(this).is(":checked");
            $("#cpiDocParamContainer .cpiDocumentCheck").prop("checked", isChecked);
        });

    }

    // check basic search parameter
    getBasicError(searchWarning) {
        let errors = ""

        // need at least one scope
        if (!($("#chkSearchData").is(":checked") || $("#chkSearchDoc").is(":checked")))     
            errors = errors + searchWarning.scopeError + "<br/>";

        // need search term
        if ($("#SimpleTerm").val().length < this.SEARCH_MIN_LENGTH)
            errors = errors + searchWarning.basicSearchError + this.SEARCH_MIN_LENGTH + "<br/>";

        // need at least one system/screen
        if (!$("#cpiSysParamContainer input[type=checkbox]:checked").length)                  // system-screen selected?
            errors = errors + searchWarning.systemError + "<br/>";

        // if document search selected, need at least one document type
        if ($("#chkSearchDoc").is(":checked")) {
            if (!$("#cpiDocParamContainer input[type=checkbox]:checked").length)                  // document selected?
                errors = errors + searchWarning.documentError + "<br/>";
        }

        return errors;
    }

    // ADVANCED SEARCH
    initializeAdvancedSearch(searchWarning) {

        const self = this;
        const advancedContainer = $("#searchAdvancedContainer");

        const dataGrid = $("#gridDataFilter");
        const docGrid = $("#gridDocFilter");
        
        // cascade search term to criteria fields in the grid
        advancedContainer.find(".cpiCascadeTermLink").on("click", function (e) {
            const searchTerm = advancedContainer.find("#CascadeTerm").val();
            if (searchTerm && searchTerm.length) {
                const tab = $("#gsCriteriaGridContainer").find(".tab-content .active").attr("id");
                if (tab) {
                    var gridData;
                    if (tab.toLowerCase().includes("data")) {
                        gridData = dataGrid.data("kendoGrid");
                    }
                    else {
                        gridData = docGrid.data("kendoGrid");
                    }
                    self.setGridCriteriaField(gridData, searchTerm);
                }
            }
        });

        self.initializeCriteriaGrid(dataGrid);
        self.initializeCriteriaGrid(docGrid);

        advancedContainer.find(".cpiGlobalSearchAdvanced").on("click", function (e) {
            e.preventDefault();

            // check for param errors
            const errors = self.getParamError(searchWarning);
            if (errors.length) {
                cpiAlert.warning(errors);
                return;
            }

            // refresh grid
            self.refreshResults();
        });
    }

    setGridCriteriaField(grid, criteria) {
        alert("yy")
        window.fsn = grid;
        if (grid && grid.dataSource) {
            const currentData = grid.dataSource.data();
            for (let i = 0; i < currentData.length; i++) {
                currentData[i]["Criteria"] = criteria;
            }
            grid.refresh();
        }
    }

    initializeCriteriaGrid(criteriaGrid) {
        const criteriaGridData = criteriaGrid.data("kendoGrid");

        // grid toolbar - clear criteria fields
        criteriaGrid.on("click", ".k-grid-ClearCriteria", function (e) {
            //e.preventDefault();
            self.setGridCriteriaField(criteriaGridData, "");
        });

        // grid toolbar - delete all rows
        criteriaGrid.on("click", ".k-grid-RemoveFilter", function (e) {
            e.preventDefault();
            const form = $(e.currentTarget).closest("form");
            const deletePrompt = form.data("removefilters-prompt");
            const title = form.data("delete-title");
            cpiConfirm.delete(title, deletePrompt, function () {
                criteriaGridData.dataSource.data([]);
            })
        });

        // grid toolbar - load all fields
        criteriaGrid.on("click", ".k-grid-LoadAll", function (e) {
            e.preventDefault();
            const form = $(e.currentTarget).closest("form");
            const loadPrompt = form.data("load-prompt");
            const title = form.data("load-title");
            cpiConfirm.warning(title, loadPrompt, function () {
                criteriaGridData.dataSource.read({ isLoadAll: true })
            })

        });

        // grid toolbar - load default fields
        criteriaGrid.on("click", ".k-grid-LoadDefault", function (e) {
            e.preventDefault();
            const form = $(e.currentTarget).closest("form");
            const loadPrompt = form.data("load-prompt");
            const title = form.data("load-title");
            cpiConfirm.warning(title, loadPrompt, function () {
                criteriaGridData.dataSource.read()
            })
        });
    }

    // check if required parameters were entered
    getParamError(searchWarning, searchMode = "x") {
        let errors = ""
        if (!$("#cpiSysParamContainer input[type=checkbox]:checked").length)                  // system-screen selected?
            errors = errors + searchWarning.systemError + "<br/>";

        if (!($("#chkSearchData").is(":checked") || $("#chkSearchDoc").is(":checked")))     // scope selected
            errors = errors + searchWarning.scopeError + "<br/>";

        if (searchMode === this.SIMPLESEARCH) {                                             // basic search term
            if ($("#SimpleTerm").val().length < this.SEARCH_MIN_LENGTH) {
                errors = errors + searchWarning.basicSearchError + this.SEARCH_MIN_LENGTH + "<br/>";
            }
        } else {                                                                            // advanced field filters
            if (!this.isFilterFieldOk()) {
                errors = errors + searchWarning.advancedSearchError + this.SEARCH_MIN_LENGTH + "<br/>";
            }
        }
        return errors;
    }

    isFilterFieldOk() {
        // need at least one criteria that passes length requirement
        let isOk = false;
        const grid = $("#gridDataFilter").data("kendoGrid");

        if (grid && grid.dataSource) {
            const data = grid.dataSource.data();
            if (data.length) {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].Criteria.length >= this.SEARCH_MIN_LENGTH) {
                        isOk = true;
                        break;
                    }
                }
            }
        }
        return isOk;
    }

    refreshResults(searchMode = "") {
        const self = this;
        // for now do doc search with simple search only
        
        if ($("#chkSearchData").is(":checked")) {
            self.showSpinner();
            self.refreshResultsGrid("globalSearchResultGridData");
        }
        if (searchMode === "s") {
            if ($("#chkSearchDoc").is(":checked")) {
                self.showSpinner();
                setTimeout(function () { self.refreshResultsGrid("globalSearchResultGridDoc"); }, 3000);        // delay to avoid concurrency issues
            }
        }
    }

    refreshResultsGrid(gridName) {
        const grid = $("#" + gridName).data("kendoGrid");
        if (grid.dataSource.page() !== 1) {
            grid.dataSource.page(1);
        }
        grid.dataSource.read();
    }


    //------------------------- CRITERIA -------------------------
    getSearchMode = () => { return $("#SearchMode").find(".btn.active input")[0].value; }

    getSearchCriteria() {
        const self = this;
        //const mode = $("#SearchMode").find(".btn.active input")[0].value;
        const mode = self.getSearchMode();

        const screens = self.getSelectedSystemScreens();
        const docTypes = self.getSelectedDocumentTypes();

        var term = "";
        var filters = [];
        if (mode === this.SIMPLESEARCH) {
            term = $("#SimpleTerm").val();
            filters.push({ OrderEntry: 0, LogicalOperator: "", FieldId: 0, Criteria: "", LeftParen: "", RightParen: "" }); // dummy for controller
        }
        else {
            filters = self.getGridFilterFields();
        } 
        const criteria = { SearchMode: mode, SystemScreens: screens, DocumentTypes: docTypes, SearchTerm: term, FieldFilters: filters };
        return { globalSearchParams: JSON.stringify(criteria) };
    }

    getGridFilterFields() {
        const grid = $("#gridDataFilter").data("kendoGrid");
        const records = [];
   
        var order = 0
        if (grid && grid.dataSource) {
            const data = grid.dataSource.data();
            for (let i = 0; i < data.length; i++) {
                if (data[i].Criteria.length) {
                    order++;
                    records.push({ OrderEntry: order, LogicalOperator: data[i].LogicalOperator, FieldId: data[i].Field.FieldId, Criteria: data[i].Criteria, LeftParen: data[i].LeftParen, RightParen: data[i].RightParen });
                }
            }
        }
        return records;
    }

    getSelectedSystemScreens() {
        const childrenSelector = "#cpiSysParamContainer .cpiScreenType .cpiSystemCheck";       // select all screen types
        var screens = "";
        $(childrenSelector).each(function () {
            if (this.checked) {
                const id = $(this).attr("id").replace("cpiScreen", "");
                screens = screens + "|" + id;
            }
        })
        if (screens.length) screens += "|"
        return screens;
    }

    getSelectedDocumentTypes() {
        const childrenSelector = "#cpiDocParamContainer .cpiDocumentCheck";       // select all screen types
        var docTypes = "";
        $(childrenSelector).each(function () {
            if (this.checked) {
                const id = $(this).attr("id").replace("gsCheck", "");
                docTypes = docTypes + "|" + id;
            }
        })
        if (docTypes.length) docTypes += "|"
        return docTypes;
    }

    deleteFilterRow(e) {
        e.preventDefault();

        const grid = $("#" + e.delegateTarget.id).data("kendoGrid");
        const form = $(e.currentTarget).closest("form");
        const deletePrompt = grid.options.editable.confirmDelete;
        const title = form.data("delete-title");
        cpiConfirm.delete(title, deletePrompt, function () {
            grid.removeRow($(e.currentTarget).closest("tr"));
            grid.dataSource._destroyed = [];
        })

        // can't use pageHelper, there is no back-end delete
        //const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        //pageHelper.deleteGridRow(e, dataItem);        

    }

   

    showSearchContainer(searchMode) {
        if (searchMode === "s") {
            $("#searchSimpleContainer").show();
            $("#searchAdvancedContainer").hide();
            $("#searchScopeContainer").show();
        }
        else {
            $("#searchSimpleContainer").hide()
            $("#searchAdvancedContainer").show()
            $("#searchScopeContainer").hide();
        }
    }

    searchResultDataBound() {
        let highlightRow = 2;
        $("#globalSearchResultGridData tr").each(function (index) {
            const row = index + 1;

            if (row >= highlightRow && row <= highlightRow) {
                $(this).addClass("altItem");

                if (row === highlightRow)
                    highlightRow = highlightRow + 2;
            }
        });
        cpiLoadingSpinner.hide();
    }   

    searchResultGridError = (e) => {
        cpiLoadingSpinner.hide();
        pageHelper.showErrors(e.xhr.responseText || "Error retrieving search results.");
    }

    redirectToRecord(link) {
        let url = $("body").data("base-url") + "/";
        url = url + link;
        window.open(url, '_blank');
    }

    initializeSearchDoc(docViewerUrl, docDownloadUrl) {
        const self = this;

        const docGrid = $("#globalSearchResultGridDoc");
        docGrid.on("click", ".docViewerLink", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const row = $(e.target).closest("tr");
            const dataItem = docGrid.data("kendoGrid").dataItem(row);
            const url = docViewerUrl + "?systemType=" + dataItem.SystemType + "&screenCode=" + dataItem.ScreenCode + "&documentType=" + dataItem.DocumentType +
                "&parentId=" + dataItem.ParentId + "&fileName=" + dataItem.FileName;

            documentPage.zoomDocument(url);
            return false;
        })


        // grid toolbar - clear criteria fields
        docGrid.on("click", ".k-grid-DownloadDoc", function (e) {
            //e.preventDefault();
            self.downloadDocs(docDownloadUrl);
        });

    }

    showSpinner() {
        if (this.spinnerCount === 0) {
            cpiLoadingSpinner.show("", 1);
        }
        this.spinnerCount = this.spinnerCount + 1;
    }

    hideSpinner() {
        this.spinnerCount = this.spinnerCount - 1;
        if (this.spinnerCount < 1) {
            cpiLoadingSpinner.hide();
        }
    }

    downloadDocs = (url) => {
        const grid = $("#globalSearchResultGridDoc").data("kendoGrid");
        const selection = grid.selectedKeyNames();
        
        if (selection.length > 0) {
            let downloadForm = $("#documentsDownload").last();
            if (downloadForm.length > 0) {
                downloadForm.remove();
            }
            $(`<form action="${url}" method="post" id="documentsDownload"><input type="hidden" name="Selection" value="${selection.join()}"/></form>`).appendTo('body').submit();
        }
    }

}


 //initializeSystemCriteria(labelOpen, labelClose) {
        //$("#toggleScreenList").click(function () {
        //    $(this).find("i").toggleClass("fal fa-chevron-down").toggleClass("fal fa-chevron-up");
        //    let btnLabel = $("#toggleScreenList .btn-text").html();
        //    if (btnLabel === labelOpen) {
        //        btnLabel = labelClose;
        //        $("#cpiSysParamContainer .collapse").collapse("show");
        //    }
        //    else {
        //        btnLabel = labelOpen;
        //        $("#cpiSysParamContainer .collapse").collapse("hide");
        //    }
        //    $("#toggleScreenList .btn-text").html(btnLabel);

        //});

        //$("#chkSystemAll").change(function () {
        //    const isChecked = $(this).is(":checked");
        //    $("#cpiSysParamContainer .k-checkbox").prop("checked", isChecked);
        //    $("#cpiSysParamContainer .cpiSystemCheck").prop("checked", isChecked);
        //});

        // system checkboxes
        //$("#cpiSysParamContainer .cpiSystemType .k-checkbox").change(function () {
        //    const parentChkboxId = $(this).attr("id");
        //    const isChecked = $("#" + parentChkboxId).is(":checked");
        //    const childrenSelector = "#cpiSysParamContainer .cpiScreenType ." + parentChkboxId;       // the children has the parent's id in its class
        //    $(childrenSelector).prop("checked", isChecked);

        //});

        // children checkboxes
        //$("#cpiSysParamContainer .cpiSystemCheck").change(function () {
        //    const classes = $(this).attr("class").split(" ");           // parent id is in the child checkbox's class
        //    const parentChkboxId = classes[classes.length - 1];
        //    // if child chkbox checked, check its parent
        //    if ($(this).is(":checked")) {
        //        $("#" + parentChkboxId).prop("checked", true);
        //    }
        //    // else uncheck its parent only if all children are unchecked
        //    else {
        //        let allClear = true;
        //        const childrenSelector = "#cpiSysParamContainer .cpiScreenType ." + parentChkboxId;       // the children has the parent's id in its class
        //        $(childrenSelector).each(function () {
        //            allClear = allClear && !this.checked;       // faster bit-wise op
        //            //if (this.checked) {
        //            //    allClear = false;
        //            //}
        //        })
        //        if (allClear) {
        //            $("#" + parentChkboxId).prop("checked", false);
        //        }
        //    }
        //});
    //}

